export const DialogTypes = {
    CreateParkingEvent: "Create Parking Event",
    SendPaymentRequest:"Send Payment Request",
    AdjustBalance: "Adjust Balance",
    ReverseParkingEntry:"Reverse Parking Entry",
    RegisterNewParker: "Register New Parker" 
};